<template>
  <div style="height: 100%">
    <el-table
      :height="height"
      :data="tableData" class="fireTable" stripe @selection-change="selectionChange">
      <el-table-column
        type="selection"
        align="right"
        width="45">
      </el-table-column>
      <el-table-column
        v-for="(item, i) in headList"
        :key="i"
        :prop="item.prop"
        align="center"
        :min-width="item.width"
        :label="item.label">
        <template slot-scope="scope">
<!--          <span v-if="item.prop === 'eventImg'">{{ scope.row.eventImg.indexOf('http') }}</span>-->
          <el-image
            v-if="item.prop === 'eventImg'"
            style="width: 60px; height: 60px"
            :src="scope.row.eventImg && scope.row.eventImg.indexOf('http') >= 0 ? scope.row.eventImg : baserUrl + scope.row.eventImg"
            :preview-src-list="[scope.row.eventImg && scope.row.eventImg.indexOf('http') >= 0 ? scope.row.eventImg : baserUrl + scope.row.eventImg]"
            fit="fill"></el-image>
          <span v-else-if="item.prop === 'sort'">
            {{ scope.$index + 1 }}
          </span>
          <span v-else-if="item.prop === 'status'">
            {{ scope.row[item.prop] | filterStatus }}
          </span>
          <span v-else-if="item.prop === 'option'">
            <span v-if="scope.row.status === 0" class="font-00FFF6" style="margin-right: 5px" @click="openRelieve(scope.row)">解除</span>
            <span class="font-00B2FF" @click="openInfo(scope.row)" style="margin-right: 5px">查看详情</span>
            <span class="font-FF1C2F" @click="openRemove(scope.row)">删除</span>
          </span>
          <span v-else>{{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { baserUrl } from "../../../../plugins/BsaeUrl";
import { warningStatus } from "../../../../utils/common";

export default {
  name: "Table",
  props: {
    tableData: { type: Array, default: () => [] },
    height: { type: Number, default: 600 }
  },
  data () {
    return {
      baserUrl: baserUrl,
      headList: [
        {label: '序号', width: '50', prop: 'sort'},
        {label: 'id', width: '50', prop: 'id'},
        {label: '所属乡镇', width: '100', prop: 'area_name'},
        {label: '设备名称', width: '100', prop: 'deviceName'},
        {label: '报警编号', width: '120', prop: 'warningNum'},
        {label: '报警时间', width: '140', prop: 'startTime'},
        {label: '区域负责人', width: '100', prop: 'gridName'},
        {label: '照片', width: '60', prop: 'eventImg'},
        {label: '状态', width: '60', prop: 'status'},
        {label: '已用时', width: '80', prop: 'statusUseHour'},
        {label: '操作', width: '140', prop: 'option'}
      ]
    }
  },
  filters: {
    filterStatus (val) {
      const list = warningStatus.filter(x => {
        return x.value === val
      })
      return list[0] ? list[0].label : '-'
    }
  },
  methods: {
    openInfo (item) {
      this.$emit('openInfo', item)
    },
    selectionChange (e) {
      this.$emit('selectionChange', e)
    },
    openRelieve (row) {
      this.$emit('openRelieve', row)
    },
    openRemove (row) {
      this.$emit('openRemove', row)
    }
  }
}
</script>

<style scoped lang="less">
.font-00FFF6{
  color: #00fff6;
  cursor: pointer;
}
.font-00B2FF{
  color: #00B2FF;
  cursor: pointer;
}
.font-FF1C2F{
  color: #FF1C2F;
  cursor: pointer;
}
/deep/ th,.el-table__cell{
  font-weight: 500;
  background-color: #00606E !important;
  border-bottom: 0 !important;
  font-size: 20px;
  color: #FFFFFF;
  padding: 0;
}
/deep/ td,.el-table__cell{
  color: #FFFFFF;
  font-size: 16px;
  border-bottom: 0 !important;
  background-color: rgba(0, 51, 71, 0) !important;
}
/deep/ .el-table tr{
  background-color: rgba(255, 255, 255, 0);
}
/deep/.el-table__row--striped{
  td{
    background-color: rgba(0, 255, 246, 0.1) !important;
  }
}
/deep/ .el-table__body-wrapper {
  &::-webkit-scrollbar{
    display: none;
  }
}
/deep/.el-checkbox__inner {
  background-color: #1d9fb5 !important;
  border-color: #1d9fb5 !important;
}
</style>
